import { useAnalytics } from "@/shared/hooks";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const useTrackPageView = () => {
  const location = useLocation();
  const { trackPageView } = useAnalytics();
  const previousPathRef = useRef("");

  useEffect(() => {
    if (location.pathname !== previousPathRef.current) {
      trackPageView(location.pathname);
      previousPathRef.current = location.pathname;
    }
  }, [location.pathname]);
};
